// src/components/organism/Users/UsersSuccessModal/UsersSuccessModal.tsx
import React from 'react';
import { Container, Row, Col, Button, IconButton, CopyIcon } from 'shared-portal-component';
import { useSelector } from 'react-redux';

import AppModal from '@/components/common/AppModal/AppModal';
import { PORTAL_URL } from '@/config/apiConfig';
import { RootState } from '@/store/rootReducer';

interface UsersSuccessModalProps {
  open: boolean;
  onClose: () => void;
  invitationLink: string;
  otp: string;
}

const UsersSuccessModal: React.FC<UsersSuccessModalProps> = ({
  open,
  onClose,
  invitationLink,
  otp,
}) => (
    <AppModal
      onClose={onClose}
      title="Invitation Details"
      aria-label="User invitation details"
      size="md"
    >
      <Container fluid>
        {/* Descriptive text from the simple modal */}
        <Row spacing="none">
          <Col>
            <p className="text-left">
              Your new user has been sent an email with information they need to configure and start
              using their PortalSIX account.
            </p>
            <p className="mt-3 text-left">
              Once they configure their account, their status will change from New to Active.
            </p>
          </Col>
        </Row>

        {/* Close button */}
        <Row spacing="none" justify="center" className="mt-6">
          <Col size="content">
            <Button
              onClick={onClose}
              variant="primary"
              text="Close"
              aria-label="Close invitation modal"
            />
          </Col>
        </Row>
      </Container>
    </AppModal>
  );

export default UsersSuccessModal;
